import { makeStyles } from "@mui/styles";
import { Alert, Box, Button, Typography } from "@mui/material";
import useSaleFactorStore from "../../../store/out-warehouse/useSaleFactorStore";
import { useGetSaleFactorDetail } from "../../../hooks/out-warehouse-with-factor/useGetSaleFactorDetail";
import SaleFactorDetailNested from "./sale-factor-detail-nested";
import LoadingSpinner from "../../global/loading-spinner";
import AddOut from "./add-out";
import AddBagCode from "./add-bag-code";
import ChangeFactorStatus from "./change-factor-status";

const useStyles = makeStyles((theme) => ({
  factorDetailTop: {
    color: "#fff",
    padding: "16px 32px",
    position: "relative",
    zIndex: "2",
    [theme.breakpoints.down("360")]: {
      padding: "16px 14px",
    },
    "&:before": {
      position: "absolute",
      content: '""',
      width: "100%",
      height: "100%",
      background: "#2530B8",
      top: "0",
      right: "0",
      borderRadius: "0 0 100px 100px",
      zIndex: "-1",
      marginBottom: "30px",
    },
    "& hr": {
      borderStyle: "dashed",
    },
  },
  factorItems: {
    padding: "52px 32px",
    [theme.breakpoints.down("360")]: {
      padding: "52px 14px",
    },
  },
}));

const SaleFactorDetail = () => {
  const classes = useStyles();
  const factorID = useSaleFactorStore((store) => store.factorID);
  const { data, isLoading } = useGetSaleFactorDetail(factorID);
  const factor_info = data?.result?.factor_info;
  const factor_items = data?.result?.factor_items;

  return (
    <>
      <Box className="page-title">خروج کالا از انبار با فاکتور</Box>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <Box className={classes.factorDetailTop}>
            {data?.status.code === -1 && (
              <Box my={5}>
                <Alert severity="info">{data?.msg}</Alert>
              </Box>
            )}
            <Box display="flex" justifyContent="space-between" mb={2}>
              <Typography variant="h3">
                شماره فاکتور:
                <Box mr={0.5} display="inline-block">
                  {factor_info.id}
                </Box>
              </Typography>
              <Typography variant="h3">{factor_info.created_at}</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" pb={1} mb={1}>
              <Typography variant="h3">
                نام تحویل گیرنده:
                <Box mr={0.5} display="inline-block">
                  {factor_info.user_name}
                </Box>
              </Typography>
              <Typography variant="h3">
                بارکد سبد:
                <Box mr={0.5} display="inline-block">
                  {factor_info.bag_barcode
                    ? factor_info.bag_barcode
                    : "وارد نشده"}
                </Box>
              </Typography>
            </Box>
            <hr />
            <Box
              display="flex"
              mt={2}
              justifyContent="space-around"
              alignItems="center"
            >
              <Typography variant="h3" display="flex" alignItems="center">
                <img
                  src={
                    process.env.PUBLIC_URL + "/assets/images/icons/truck.svg"
                  }
                  alt="kiamia-shop"
                />
                <Box mr={0.85} display="inline-block">
                  {factor_info.status}
                </Box>
              </Typography>
              {factor_info.change_status === 1 && (
                <ChangeFactorStatus factorID={factor_info.id} />
              )}
            </Box>
            <Typography variant="h3" mt={2}>
              توضیحات فاکتور:
              <Box mr={0.5} display="inline-block">
                {factor_info.description ? factor_info.description : "ندارد"}
              </Box>
            </Typography>
            {factor_info.bag_barcode ? (
              <AddOut factorID={factor_info.id} />
            ) : (
              <AddBagCode factorID={factor_info.id} />
            )}
          </Box>
          <Box className={classes.factorItems}>
            {factor_info.bag_barcode ? (
              factor_items.map(({ ...otherProps }, index) => (
                <SaleFactorDetailNested key={index} {...otherProps} />
              ))
            ) : (
              <Alert severity="warning">ابتدا بارکد سبد را وارد کنید.</Alert>
            )}
          </Box>
        </>
      )}
    </>
  );
};
export default SaleFactorDetail;
